// Limpieza defensiva de cookies del dominio del propio frontend al cerrar sesión.
// Nota: por seguridad del navegador, esto SOLO puede borrar cookies legibles desde
// document.cookie en este dominio/path (no HttpOnly, y nunca cookies de otro
// dominio como el del API/gateway). Hoy la app no setea cookies de sesión; esto
// cubre cualquier cookie que llegue a existir a futuro (ej. analítica) para que
// no quede nada asociado al dominio tras el logout.
export const clearAllCookies = () => {
  if (typeof document === "undefined" || !document.cookie) return;

  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = (eqPos > -1 ? cookie.substring(0, eqPos) : cookie).trim();
    if (!name) return;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};
